module.exports = __webpack_public_path__ + "static/media/16-Essen@2x.f0b94b88.jpg";